<template>
  <div class="about">
    <p class="text">
      Feel free to help me out. You can either use KOFI, Patreon or ask for a
      Paypal donation link!
    </p>
    <div class="buttons">
      <a href="https://ko-fi.com/O5O5E16J0" target="_blank"
        ><img
          height="36"
          style="border:0px;height:36px;"
          src="https://cdn.ko-fi.com/cdn/kofi2.png?v=3"
          border="0"
          alt="Buy Me a Coffee at ko-fi.com"
      /></a>

      <b-button pill variant="primary">
        <a href="https://www.patreon.com/mxrkw" target="_blank" class="text">
          Patreon
        </a></b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      items: [],
    };
  },
  mounted() {},
};
</script>

<style>
.text {
  color: white;
  text-align: center;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
</style>
